/** function for generate errors from BE for assign token to wallboxex */
export const assignTokenApiErrors: Record<string, string> = {
  BAD_REQUEST: 'emobility.api-errors.bad-request',
  WALLBOX_MANIPULATION_NOT_ALLOWED: 'emobility.api-errors.wallbox-manipulation-not-allowed',
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  TOKEN_LINK_NOT_FOUND: 'emobility.api-errors.token-link-not-found',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
  WALLBOX_NOT_FOUND: 'emobility.api-errors.wallbox-not-found',
  WALLBOX_ALREADY_ASSIGNED: 'emobility.api-errors.wallbox-already-assigned',
  EVSE_ID_NOT_FOUND: 'emobility.api-errors.evse-not-found',
  TOKEN_IS_DELETED: 'emobility.api-errors.token-is-deleted',
  USER_NOT_FOUND: 'emobility.api-errors.user-not-found',
}
